/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import i18next from "../../i18n/i18n";

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      textAlign: "left",
      "& ul": {
        display: "inline-block",
        textAlign: "center",
        padding: "0",
        "& li": {
          display: "inline-block",
          listStyle: "none",
          "& a": {
            color: "white",
            textDecoration: "none",
            padding: "0 1rem",
            borderRight: "1px solid white",
            fontSize: "0.75rem",
            "&:hover": {
              textDecoration: "underline"
            }
          },
          "&:last-child": {
            "& a": {
              borderRight: "none"
            }
          }
        }
      }
    }
  })
);

const EAFooterLinks = ({registrationTheme}) => {
  const css = useStyles();

  let gdprLink = "";
  let cguLink = "";
  let securityLink = "footerLinks.security.url";
  switch(registrationTheme){
    case "365":
      gdprLink = "footerLinks.GDPR.url360";
      cguLink = "footerLinks.CGU.url360";
      break;
    case "portal":
      gdprLink = "footerLinks.GDPR.portal";
      cguLink = "footerLinks.CGU.portal";
      break;

  }
  return (
    <div className={css.root}>
      <ul>
        <li>
          <a
            href={i18next.t(gdprLink)}
            target="_blank"
          >
            {i18next.t("footerLinks.GDPR.label")}
          </a>
        </li>
        <li>
          <a
            href={i18next.t(securityLink)}
            target="_blank"
          >
            {i18next.t("footerLinks.security.label")}
          </a>
        </li>
        <li>
          <a
            href={i18next.t(cguLink)}
            target="_blank"
          >
            {i18next.t("footerLinks.CGU.label")}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default EAFooterLinks;
